import { Expose, Type } from 'class-transformer';
import { UserDetailsDto } from './user-details.dto';

export class LoginByTokenResponseDto {
  @Expose({ name: 'userDetails' })
  @Type(() => UserDetailsDto)
  userDetails: UserDetailsDto;
}
